/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { ledgersCountLedgersApiV2LedgersCountGet } from "../../funcs/ledgersCountLedgersApiV2LedgersCountGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CountLedgersApiV2LedgersCountGetRequest$inboundSchema
    .optional(),
};

export const tool$ledgersCountLedgersApiV2LedgersCountGet: ToolDefinition<
  typeof args
> = {
  name: "ledgers-count-ledgers-api-v2-ledgers-count-get",
  description: `Count ledgers`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await ledgersCountLedgersApiV2LedgersCountGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
